import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

const Hero = () => {
  const scrollToContact = () => {
    const element = document.getElementById("kontakt");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-start overflow-x-hidden bg-gradient-to-br from-[#0f1419] via-[#1a2332] to-[#2c4a52]"
    >
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-20 right-20 w-96 h-96 bg-[#4a9da8]/10 rounded-full blur-3xl float-element"></div>
        <div className="absolute bottom-20 left-20 w-96 h-96 bg-[#2c4a52]/20 rounded-full blur-3xl float-element" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-1/2 left-1/2 w-96 h-96 bg-[#4a9da8]/5 rounded-full blur-3xl float-element" style={{animationDelay: '4s'}}></div>
      </div>

      {/* Grid overlay for depth */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHBhdHRlcm4gaWQ9ImdyaWQiIHdpZHRoPSI2MCIgaGVpZ2h0PSI2MCIgcGF0dGVyblVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+PHBhdGggZD0iTSAxMCAwIEwgMCAwIDAgMTAiIGZpbGw9Im5vbmUiIHN0cm9rZT0icmdiYSgyNTUsMjU1LDI1NSwwLjAzKSIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2dyaWQpIi8+PC9zdmc+')] opacity-40"></div>

      <div
        className="container-custom relative z-10 pb-[7rem] md:pb-[8rem] hero-content"
        style={{ paddingTop: "calc(var(--header-height, 6rem) + 3rem)" }}
      >
        <div className="max-w-5xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 glass text-white/90 rounded-full mb-6 md:mb-8 fade-in">
            <Sparkles className="w-4 h-4 text-[#4a9da8]" />
            <span className="text-sm font-medium">Strukturierte Social-Media-Betreuung</span>
          </div>

          {/* Main Heading – Proportionen so, dass nichts abgeschnitten wird */}
          <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl xl:text-7xl font-bold text-white mb-6 md:mb-8 leading-[1.15] tracking-tight fade-in-left max-w-4xl" style={{animationDelay: '0.2s'}}>
            Digitale Vermarktung
            <br />
            <span className="gradient-text-hero">braucht Klarheit.</span>
          </h1>

          {/* Subheading with accent line */}
          <div className="accent-line mb-12 fade-in-right" style={{animationDelay: '0.4s'}}>
            <p className="text-xl md:text-2xl text-[#e8e4dc] leading-relaxed font-light max-w-3xl">
              Wir unterstützen Unternehmen dabei, ihre Social-Media-Präsenz 
              <span className="text-[#4a9da8] font-medium"> strukturiert, nachvollziehbar und messbar </span>
              umzusetzen.
            </p>
          </div>

          {/* CTA with modern design */}
          <div className="flex flex-col sm:flex-row gap-4 scale-in" style={{animationDelay: '0.6s'}}>
            <button
              onClick={scrollToContact}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 bg-gradient-to-r from-[#2c4a52] to-[#4a9da8] text-white text-lg font-semibold rounded-xl hover:shadow-2xl hover:shadow-[#4a9da8]/20 hover:scale-105 transition-all duration-300 group"
            >
              Kostenlose Marketing-Beratung
              <ArrowRight className="w-5 h-5 group-hover:translate-x-2 transition-transform" />
            </button>
            
            <button
              onClick={() => document.getElementById("leistungen").scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center justify-center gap-3 px-8 py-4 glass text-white text-lg font-medium rounded-xl hover:bg-white/20 transition-all duration-300"
            >
              Mehr erfahren
            </button>
          </div>
          
          {/* Stats or trust indicators 
          <div className="flex flex-wrap gap-8 mt-16 fade-in" style={{animationDelay: '0.8s'}}>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-[#4a9da8]/20 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-[#4a9da8]">3+</span>
              </div>
              <div>
                <p className="text-white/60 text-sm">Jahre</p>
                <p className="text-white font-medium">Expertise</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-[#4a9da8]/20 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-[#4a9da8]">50+</span>
              </div>
              <div>
                <p className="text-white/60 text-sm">Erfolgreiche</p>
                <p className="text-white font-medium">Projekte</p>
              </div>
            </div>
            
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-[#4a9da8]/20 rounded-lg flex items-center justify-center">
                <span className="text-2xl font-bold text-[#4a9da8]">100%</span>
              </div>
              <div>
                <p className="text-white/60 text-sm">Volle</p>
                <p className="text-white font-medium">Transparenz</p>
              </div>
            </div>
          </div>*/}
        </div>
      </div>

      <style jsx>{`
        .gradient-text-hero {
          background: linear-gradient(135deg, #4a9da8, #e8e4dc);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }
      `}</style>
    </section>
  );
};

export default Hero;
